import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API_BASE_URL, profileAPI, feedbackAPI, withFileToken } from "../services/api";
// import { compressImage } from "../utils/helpers"; // TODO: aktifkan lagi saat upload foto profil siap
import { PageLoader } from "../components/common/LoadingSpinner";
import { clearCache } from "../utils/cache";

const ODOO_BASE = API_BASE_URL;

// Label ramah untuk kode tipe kehadiran (dari sync Odoo attendance_type).
const ATTENDANCE_TYPE_LABEL = {
  regular: "Reguler",
  sales: "Sales",
  ecommerce: "E-commerce",
  sopir: "Sopir",
  driver: "Sopir",
};
const attendanceTypeLabel = (t) =>
  t ? ATTENDANCE_TYPE_LABEL[String(t).toLowerCase()] || t : "-";

function GroupCard({ title, rows }) {
  return (
    <section className="rounded-xl bg-gray-100 p-3.5">
      <h2 className="px-1 pb-2 text-[13px] font-black text-gray-900">{title}</h2>
      <div className="space-y-1">
        {rows.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={item.onClick}
            disabled={!item.onClick}
            className="grid min-h-[36px] w-full grid-cols-[24px_minmax(0,1fr)_auto] items-center gap-2 rounded-lg px-1.5 text-left transition active:bg-white/70 disabled:active:bg-transparent"
          >
            <span className="flex h-6 w-6 items-center justify-center text-gray-500">{item.icon}</span>
            <span className="truncate text-[12px] font-bold text-gray-800">{item.label}</span>
            <span className="max-w-[140px] truncate text-right text-[11px] font-bold text-gray-400">{item.value}</span>
          </button>
        ))}
      </div>
    </section>
  );
}

function PhotoActionButton({ label, icon, onClick }) {
  return (
    <button type="button" onClick={onClick} className="flex w-full items-center gap-2.5 px-3.5 py-3 text-left text-[12px] font-black text-gray-800 active:bg-gray-50 transition">
      {icon}
      {label}
    </button>
  );
}

export default function ProfilePage() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  // Upload foto profil DINONAKTIFKAN SEMENTARA (belum berhasil, diperbaiki nanti).
  // const [uploadingPhoto, setUploadingPhoto] = useState(false);
  // const [photoError, setPhotoError] = useState("");
  const [sheetOpen, setSheetOpen] = useState(false);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [toast, setToast] = useState(null);

  // Customer support / kritik & saran (sementara: teks saja, tanpa lampiran)
  const [supportOpen, setSupportOpen] = useState(false);
  const [fbCategory, setFbCategory] = useState("KRITIK_SARAN");
  const [fbMessage, setFbMessage] = useState("");
  // const [fbFile, setFbFile] = useState(null); // lampiran dinonaktifkan sementara
  const [fbSending, setFbSending] = useState(false);

  const showToast = (type, msg) => {
    setToast({ type, msg });
    window.clearTimeout(showToast._t);
    showToast._t = window.setTimeout(() => setToast(null), 3800);
  };

  const openSheet = () => setSheetOpen(true);
  const closeSheet = () => setSheetOpen(false);
  const openViewer = () => {
    setSheetOpen(false);
    setViewerOpen(true);
  };

  // ── UPLOAD FOTO PROFIL DINONAKTIFKAN SEMENTARA ──────────────────
  // Fitur upload belum berhasil (multipart), akan diperbaiki di iterasi berikut.
  // Kode di bawah disimpan (dikomentari) agar mudah diaktifkan kembali.
  // const readAsDataURL = (file) =>
  //   new Promise((resolve, reject) => {
  //     const r = new FileReader();
  //     r.onload = () => resolve(r.result);
  //     r.onerror = () => reject(new Error("Gagal membaca file"));
  //     r.readAsDataURL(file);
  //   });
  //
  // const handlePhotoChange = async (e) => {
  //   const file = e.target.files?.[0];
  //   e.target.value = "";
  //   setSheetOpen(false);
  //   if (!file) return;
  //   if (!file.type.startsWith("image/")) {
  //     showToast("error", "File harus berupa gambar (JPG/PNG).");
  //     return;
  //   }
  //   setUploadingPhoto(true);
  //   setPhotoError("");
  //   try {
  //     let payload;
  //     try {
  //       const dataUrl = await readAsDataURL(file);
  //       payload = await compressImage(dataUrl, 512, 0.8);
  //     } catch (compressErr) {
  //       console.warn("[foto profil] kompres gagal, unggah file asli:", compressErr);
  //       payload = file;
  //     }
  //     await profileAPI.updatePhoto(payload);
  //     const fresh = await profileAPI.get({ force: true });
  //     setProfile(fresh);
  //     showToast("success", "Foto profil berhasil diperbarui.");
  //   } catch (err) {
  //     console.error("[foto profil] gagal:", err);
  //     const msg = err?.message || "Gagal mengunggah foto. Coba lagi.";
  //     setPhotoError(msg);
  //     showToast("error", msg);
  //   } finally {
  //     setUploadingPhoto(false);
  //   }
  // };

  useEffect(() => {
    const handleFocus = async () => {
      setLoading(true);
      try {
        const data = await profileAPI.get({ force: true });
        setProfile(data || user);
      } finally {
        setLoading(false);
      }
    };
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [user]);

  useEffect(() => {
    profileAPI.get()
      .then((data) => setProfile(data || user))
      .catch(() => setProfile(user))
      .finally(() => setLoading(false));
  }, [user]);

  const handleLogout = () => {
    clearCache();
    logout();
  };

  const openSupport = () => {
    setFbCategory("KRITIK_SARAN");
    setFbMessage("");
    setSupportOpen(true);
  };

  // Lampiran feedback DINONAKTIFKAN SEMENTARA (upload belum siap) → kirim teks saja.
  // const handleFbFile = (e) => {
  //   const file = e.target.files?.[0];
  //   e.target.value = "";
  //   if (!file) return;
  //   const okType = file.type.startsWith("image/") || file.type === "application/pdf";
  //   if (!okType) {
  //     showToast("error", "Lampiran harus gambar (JPG/PNG) atau PDF.");
  //     return;
  //   }
  //   if (file.size > 10 * 1024 * 1024) {
  //     showToast("error", "Ukuran lampiran maksimal 10 MB.");
  //     return;
  //   }
  //   setFbFile(file);
  // };

  const submitFeedback = async () => {
    const msg = fbMessage.trim();
    if (!msg) {
      showToast("error", "Tulis dulu pesan Anda ya.");
      return;
    }
    setFbSending(true);
    try {
      await feedbackAPI.submit({ category: fbCategory, message: msg });
      setSupportOpen(false);
      showToast("success", "Terima kasih! Masukan Anda sudah kami terima. 🙌");
    } catch (err) {
      showToast("error", err?.message || "Gagal mengirim. Coba lagi.");
    } finally {
      setFbSending(false);
    }
  };

  if (loading) return <PageLoader />;

  const p = profile || user || {};
  const initials = (p.name || "U")
    .split(" ")
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
  const avatarSrc =
    (p.photo_url ? withFileToken(p.photo_url) : "") ||
    (p.image
      ? `data:image/png;base64,${p.image}`
      : p.image_url
        ? `${ODOO_BASE}${p.image_url}`
        : "");

  const contactRows = [
    { label: "Badge ID", value: p.badge_number || p.barcode || "-", icon: <BadgeIcon /> },
    { label: "Email", value: p.work_email || "-", icon: <MailIcon /> },
    { label: "Mobile", value: p.mobile_phone || p.work_phone || "-", icon: <PhoneIcon /> },
  ];

  const workRows = [
    { label: "Department", value: p.department || "-", icon: <BriefcaseIcon /> },
    { label: "Job Position", value: p.job_title || "-", icon: <UserIcon /> },
    { label: "Manager", value: p.parent_id?.name || "-", icon: <UsersIcon /> },
    { label: "Work Location", value: p.work_location?.name || p.location || "-", icon: <LocationIcon /> },
  ];

  const appRows = [
    { label: "Employee Type", value: attendanceTypeLabel(p.attendance_type), icon: <ClockIcon /> },
    { label: "App Version", value: "v2.1.2", icon: <ShieldIcon /> },
  ];

  return (
    <div className="relative min-h-[calc(100dvh-80px)] overflow-hidden bg-white text-gray-900 antialiased">

      {toast && (
        <div className={`fixed top-4 left-1/2 -translate-x-1/2 z-[60] max-w-[90%] rounded-xl px-4 py-2.5 text-center text-[13px] font-black text-white shadow-lg ${toast.type === "success" ? "bg-green-600" : "bg-red-600"}`}>
          {toast.msg}
        </div>
      )}

      {/* Customer support — icon pojok kanan atas → buka form kritik & saran */}
      <button
        type="button"
        onClick={openSupport}
        aria-label="Kritik & saran / bantuan"
        className="absolute right-4 top-4 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 active:scale-95 transition"
      >
        <SupportIcon />
      </button>

      <main className="relative px-5 pt-5 pb-5">
        <section className="pt-2 text-center">
          <button
            type="button"
            onClick={avatarSrc ? openSheet : undefined}
            aria-label="Lihat foto profil"
            className="relative mx-auto mb-2.5 flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-full bg-gray-100 active:scale-[0.98] transition"
          >
              {avatarSrc ? (
                <img src={avatarSrc} alt="avatar" className="h-full w-full object-cover" />
              ) : (
                <span className="text-lg font-black text-primary">{initials}</span>
              )}
          </button>

          {/* GANTI FOTO PROFIL DINONAKTIFKAN SEMENTARA (upload belum siap) —
              input file & opsi kamera/pilih-file dikomentari. Lihat foto tetap aktif.
          <input id="profilePhotoCamera" type="file" accept="image/*" capture="user" onChange={handlePhotoChange} className="hidden" />
          <input id="profilePhotoFile" type="file" accept="image/*" onChange={handlePhotoChange} className="hidden" /> */}

          {sheetOpen && avatarSrc && (
            <>
              <div className="fixed inset-0 z-20" onClick={closeSheet} />
              <div className="absolute left-1/2 top-[104px] z-30 w-44 -translate-x-1/2 overflow-hidden rounded-xl border border-gray-100 bg-white">
                <PhotoActionButton label="Lihat Foto" icon={<EyeIcon />} onClick={openViewer} />
                {/* Opsi ganti foto (kamera/file) dinonaktifkan sementara */}
              </div>
            </>
          )}

          <h2 className="mx-auto max-w-[260px] truncate text-[17px] font-black leading-tight text-gray-900">{p.name || "Karyawan"}</h2>
          <p className="mx-auto mt-0.5 max-w-[260px] truncate text-[10px] font-semibold text-gray-400">{p.work_email || p.job_title || "Employee"}</p>
          {/* Tombol "Edit profile" (ganti foto) dinonaktifkan sementara sampai upload siap. */}
        </section>

        <div className="mt-5 space-y-3">
          <GroupCard title="Contact info" rows={contactRows} />
          <GroupCard title="Work profile" rows={workRows} />
          <GroupCard title="Apps" rows={appRows} />

          <button onClick={openSupport} className="flex min-h-[44px] w-full items-center justify-center gap-2 rounded-xl border border-emerald-100 bg-emerald-50 px-4 text-[12px] font-black text-emerald-700 active:bg-emerald-100 transition">
            <SupportIcon />
            Kritik & Saran
          </button>

          {isAdmin && (
            <button onClick={() => navigate("/admin")} className="flex min-h-[44px] w-full items-center justify-center gap-2 rounded-xl bg-primary px-4 text-[12px] font-black text-white active:scale-[0.98] transition">
              <ShieldIcon />
              Buka Admin Dashboard
            </button>
          )}

          <button onClick={handleLogout} className="flex min-h-[44px] w-full items-center justify-center gap-2 rounded-xl border border-red-100 bg-white px-4 text-[12px] font-black text-primary active:bg-gray-50 transition">
            <LogoutIcon />
            Sign Out
          </button>
        </div>
      </main>

      {supportOpen && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 sm:items-center" onClick={() => !fbSending && setSupportOpen(false)}>
          <div
            className="w-full max-w-[430px] rounded-t-2xl bg-white p-5 pb-6 sm:rounded-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-3 flex items-start justify-between">
              <div className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
                  <SupportIcon />
                </span>
                <div>
                  <h3 className="text-[15px] font-black leading-tight text-gray-900">Kritik & Saran</h3>
                  <p className="text-[10px] font-semibold text-gray-400">Bantu kami jadi lebih baik</p>
                </div>
              </div>
              <button type="button" onClick={() => !fbSending && setSupportOpen(false)} aria-label="Tutup" className="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 active:bg-gray-100 transition">
                <CloseIcon />
              </button>
            </div>

            <p className="mb-3 text-[12px] font-semibold leading-relaxed text-gray-500">
              Punya masukan, ide, atau menemukan kendala saat memakai aplikasi? Ceritakan lewat pesan di bawah.
              Setiap kritik dan saran Anda langsung kami baca dan jadi bahan penting untuk membuat aplikasi ini
              makin nyaman dipakai. Terima kasih sudah membantu! 🙌
            </p>

            {/* Jenis masukan */}
            <div className="mb-3 grid grid-cols-3 gap-1.5">
              {[
                { k: "KRITIK_SARAN", label: "Kritik & Saran" },
                { k: "BUG", label: "Bug / Error" },
                { k: "LAINNYA", label: "Lainnya" },
              ].map((opt) => (
                <button
                  key={opt.k}
                  type="button"
                  onClick={() => setFbCategory(opt.k)}
                  className={`rounded-lg px-2 py-2 text-[11px] font-black transition ${
                    fbCategory === opt.k ? "bg-emerald-600 text-white" : "bg-gray-100 text-gray-500 active:bg-gray-200"
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            <textarea
              value={fbMessage}
              onChange={(e) => setFbMessage(e.target.value)}
              rows={5}
              maxLength={5000}
              placeholder="Tulis kritik, saran, ide, atau kendala yang Anda alami. Sebutkan juga divisi & email Anda agar mudah kami hubungi. Makin detail makin baik…"
              className="w-full resize-none rounded-xl border border-gray-200 p-3 text-[12px] font-semibold text-gray-800 placeholder:font-medium placeholder:text-gray-400 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-100"
            />

            {/* LAMPIRAN SCREENSHOT DINONAKTIFKAN SEMENTARA (upload belum siap) — kirim teks saja.
            <input id="fbFileInput" type="file" accept="image/*,application/pdf" onChange={handleFbFile} className="hidden" />
            {fbFile ? (
              <div className="mt-2 flex items-center justify-between rounded-lg bg-gray-50 px-3 py-2">
                <span className="flex items-center gap-2 truncate text-[11px] font-bold text-gray-600">
                  <PaperclipIcon />
                  <span className="truncate">{fbFile.name}</span>
                </span>
                <button type="button" onClick={() => setFbFile(null)} className="text-[11px] font-black text-red-500 active:opacity-70">
                  Hapus
                </button>
              </div>
            ) : (
              <label htmlFor="fbFileInput" className="mt-2 flex cursor-pointer items-center justify-center gap-2 rounded-lg border border-dashed border-gray-300 px-3 py-2.5 text-[11px] font-black text-gray-500 active:bg-gray-50 transition">
                <PaperclipIcon />
                Lampirkan screenshot (opsional)
              </label>
            )} */}

            <button
              type="button"
              onClick={submitFeedback}
              disabled={fbSending}
              className="mt-4 flex min-h-[46px] w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 px-4 text-[13px] font-black text-white active:scale-[0.99] disabled:opacity-60 transition"
            >
              {fbSending ? (
                <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" />
              ) : (
                <>
                  <SendIcon />
                  Kirim Masukan
                </>
              )}
            </button>
          </div>
        </div>
      )}

      {viewerOpen && avatarSrc && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setViewerOpen(false)}>
          <img src={avatarSrc} alt="Foto profil" className="max-h-full max-w-full rounded-xl object-contain" />
          <button type="button" onClick={() => setViewerOpen(false)} aria-label="Tutup" className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white active:bg-white/25 transition">
            <CloseIcon />
          </button>
        </div>
      )}
    </div>
  );
}

// Dipakai lagi saat upload foto profil / lampiran feedback diaktifkan kembali.
// function CameraIcon() { return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3Z" /><circle cx="12" cy="13" r="3" /></svg>; }
function EyeIcon() { return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="text-primary"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" /><circle cx="12" cy="12" r="3" /></svg>; }
// function UploadIcon() { return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="text-primary"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="M17 8 12 3 7 8" /><path d="M12 3v12" /></svg>; }
function BadgeIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M8 10h8" /><path d="M8 14h5" /></svg>; }
function MailIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>; }
function PhoneIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.18 4.18 2 2 0 0 1 4.16 2h3a2 2 0 0 1 2 1.72c.12.86.32 1.7.62 2.5a2 2 0 0 1-.45 2.11L8.1 9.9a16 16 0 0 0 6 6l1.57-1.23a2 2 0 0 1 2.11-.45c.8.3 1.64.5 2.5.62A2 2 0 0 1 22 16.92Z" /></svg>; }
function BriefcaseIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M3 13h18" /></svg>; }
function UserIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>; }
function UsersIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>; }
function LocationIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 5.5-8 11-8 11s-8-5.5-8-11a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>; }
function ClockIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>; }
function ShieldIcon() { return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" /></svg>; }
function LogoutIcon() { return <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></svg>; }
function CloseIcon() { return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>; }
function SupportIcon() { return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 15v-3a8 8 0 0 1 16 0v3" /><path d="M18 19a2 2 0 0 1-2 2h-2" /><rect x="2" y="14" width="4" height="6" rx="1" /><rect x="18" y="14" width="4" height="6" rx="1" /></svg>; }
// function PaperclipIcon() { return <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m21.44 11.05-9.19 9.19a5 5 0 0 1-7.07-7.07l9.19-9.19a3.5 3.5 0 0 1 4.95 4.95l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" /></svg>; }
function SendIcon() { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="m22 2-7 20-4-9-9-4 20-7Z" /><path d="M22 2 11 13" /></svg>; }
